import { PageHeader } from "@/components/FilterBar";
import { CommissionPanel } from "@/components/CommissionPanel";
import { LodgifyFactures } from "@/components/LodgifyFactures";

export default function Plateformes() {
  return (
    <div data-testid="plateformes-page">
      <PageHeader eyebrow="Configuration" title="Paramètres plateformes" />
      <CommissionPanel />
      <div className="mt-6"><LodgifyFactures /></div>
    </div>
  );
}
